<template>

    <div>
        <b-card class="shadow mb-5 ml-md-5 mr-md-5 ml-0 mr-0 p-3">

            <div class="d-flex w-100 align-items-center justify-content-center flex-column mb-5">
                <div class="avatar mb-3">
                    <b-icon icon="person" />
                </div>
                <span class="h3 text-center">{{ userFullName }}</span>
            </div>

            <div class="border-bottom mb-3 pb-3">
                <div class="pt-3">
                    <span class="h4 mb-3">Персональная информация</span>
                    <div class="d-flex flex-column">
                        <div class="d-flex flex-column-reverse flex-md-row pt-3">
                            <div class="d-flex flex-grow-1 flex-wrap">

                                    <form-field class="col-sm-5 col-md-3 mr-0 mr-sm-4 p-0 mb-3"
                                                 :label="getFieldLabel('lastName')"
                                                 :editable="getAbility('lastName')"
                                                 :value="object.lastName"
                                                 :feedback="liveFeedback('lastName')">
                                        <template #field>
                                            <b-form-input
                                                id="lastName"
                                                class="w-100"
                                                type="text"
                                                v-model="$v.form.lastName.$model"
                                                :state="validateState('lastName')">
                                            </b-form-input>
                                        </template>
                                    </form-field>

                                    <form-field class="col-sm-5 col-md-3 mr-0 mr-sm-4 p-0 mb-3"
                                                 :label="getFieldLabel('firstName')"
                                                 :editable="getAbility('firstName')"
                                                 :value="object.firstName"
                                                 :feedback="liveFeedback('firstName')">
                                        <template #field>
                                            <b-form-input
                                                id="firstName"
                                                class="w-100"
                                                type="text"
                                                v-model="$v.form.firstName.$model"
                                                :state="validateState('firstName')">
                                            </b-form-input>
                                        </template>
                                    </form-field>

                                    <form-field class="col-sm-5 col-md-3 mr-0 mr-sm-4 p-0 mb-3"
                                                 :label="getFieldLabel('secondName')"
                                                 :editable="getAbility('secondName')"
                                                 :value="object.secondName"
                                                 :feedback="liveFeedback('secondName')">
                                        <template #field>
                                            <b-form-input
                                                id="secondName"
                                                class="w-100"
                                                type="text"
                                                v-model="$v.form.secondName.$model"
                                                :state="validateState('secondName')">
                                            </b-form-input>
                                        </template>
                                    </form-field>

                            </div>
                            <div class="mb-3">
                                <b-badge class="flex-grow-0 p-2">
                                    <span v-if="isSuperuser">
                                        <b-icon icon="brightness-high" class="mr-2"/>
                                        <span>Администратор</span>
                                    </span>
                                    <span v-else>
                                        <b-icon icon="person" class="mr-2" />
                                        <span>Пользователь</span>
                                    </span>
                                </b-badge>
                            </div>
                        </div>
                        <div>
                            <b-button variant="link" @click="showPasswordChangeModal()" class="m-0 p-0">Сменить пароль</b-button>
                        </div>
                    </div>
                </div>
            </div>

            <div class="border-bottom mb-3">
                <div class="pt-3">
                    <div class="mb-4 d-flex flex-column flex-sm-row align-items-center">
                      <span class="h4 mr-3 mb-0">Организация</span>
                      <b-button variant="link" class="m-0 p-0"
                                :to="{ name: 'organizationDetail', params: { id: this.userOrganization.id } }">
                        <b-icon icon="pencil-square" />
                      </b-button>
                    </div>
                    <div class="d-flex flex-column mb-4">
                        <div class="d-flex pt-3">
                            <div class="d-flex flex-grow-1  flex-wrap mb-2">
                                <span class="flex-grow-1 mr-4 d-flex flex-column mb-2">
                                    <small class="text-secondary">Название</small>
                                    <span>{{ organizationName }}</span>
                                </span>
                                <span class="flex-grow-1 mr-4 mb-2 d-flex flex-column">
                                    <small class="text-secondary">Группы</small>
                                    <span class="d-flex flex-wrap">
                                        <span class="tag" v-for="(v, i) in organizationGroups">
                                            {{ v }}
                                        </span>
                                    </span>
                                </span>
                               <span class="flex-grow-1  mb-2 mr-4 d-flex flex-column">
                                    <small class="text-secondary">Виды деятельности</small>
                                    <span class="d-flex flex-wrap">
                                        <span class="tag" v-for="(v, i) in organizationActivities">
                                            {{ v }}
                                        </span>
                                    </span>
                                </span>
                            </div>
                        </div>
                        <div>
                            <form-field class="col-sm-5 col-md-3 mr-0 mr-sm-4 p-0 mb-3"
                                         :label="getFieldLabel('position')"
                                         :editable="getAbility('position')"
                                         :value="object.position"
                                         :feedback="liveFeedback('position')">
                                <template #field>
                                    <b-form-input
                                        id="position"
                                        class="w-100"
                                        type="text"
                                        v-model="$v.form.position.$model"
                                        :state="validateState('position')">
                                    </b-form-input>
                                </template>
                            </form-field>
                        </div>

                    </div>
                </div>
            </div>

            <div class="mb-4">
                <div class="pt-3">
                    <span class="h4 mb-3">Контакты</span>
                    <div class="d-flex flex-column">
                        <div class="d-flex pt-3 pb-3">
                            <div class="d-flex flex-grow-1  flex-wrap">
                                <form-field class="col-sm-5 col-md-3 mr-0 mr-sm-4 p-0 mb-3"
                                             :label="getFieldLabel('phone')"
                                             :editable="getAbility('phone')"
                                             :value="object.phone"
                                             :feedback="liveFeedback('phone')">
                                    <template #field>
                                        <b-form-input
                                            id="phone"
                                            class="w-100"
                                            type="text"
                                            v-model="$v.form.phone.$model"
                                            :state="validateState('phone')">
                                        </b-form-input>
                                    </template>
                                </form-field>
                                <span class="flex-grow-1  mr-4 mb-4 d-flex flex-column">
                                    <small class="text-secondary">E-mail</small>
                                    <span>{{ email }}</span>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <object-form-buttons :has-changes="hasChanges"
                 :object-exists="true"
                 @object-update="update"
                 @object-cancel-changes="cancelChanges"/>

        </b-card>


        <b-modal id="password-change" hide-footer hide-header :content-class="{ 'shake': animated }">
            <template #default>
                <password-change-form @modal-closed="$bvModal.hide('password-change')"
                                      @form-error-received="onPasswordFormError"
                                      @form-error-reset="onPasswordFormErrorReset"/>
            </template>
        </b-modal>

        <confirm-leave-modal ref="leaveDialog" :silent-leave="silentLeave" :leave-browser-confirm="hasChanges"/>
    </div>

</template>

<script>
    import Spinner from "../components/Spinner";
    import {mapGetters} from "vuex";
    import {ACTIVITY_NAMES, USER_GROUP_NAMES} from "@/store/auth/auth";
    import PasswordChangeForm from "@/components/Auth/PasswordChangeForm.vue";
    import {ObjectComponentMixin} from "@/components/Forms/ObjectComponentMixin";
    import api from "@/api";
    import {Profile} from "@/pages/profile";
    import FormField from "@/components/Forms/FormField.vue";
    import ConfirmLeaveModal from "@/components/Forms/ConfirmLeaveModal.vue";
    import ObjectFormButtons from "@/components/Forms/ObjectFormButtons.vue";
    import httpClient from "@/http";
    import AuthConstants from '../store/auth/constants';

    export default {
        name: "Profile",
        mixins: [ ObjectComponentMixin ],
        components: {
            ObjectFormButtons,
            ConfirmLeaveModal,
            FormField,
            PasswordChangeForm,
            Spinner
        },
        data() {
            return {
                animated: false,
            }
        },
        computed: {
            ...mapGetters(['ability', 'userFullName', 'userOrganization', 'userObject',
                'isSuperuser', 'userOrganizationActivities', 'userGroups', 'isInContractor', 'isInController']),
            email() { return this.userObject['email'] ? this.userObject['email'] : '-' },
            organizationName() { return this.userOrganization['name'] ? this.userOrganization['name'] : '-' },
            organizationGroups() {
                const groups = this.userGroups.length ? this.userGroups : [];
                let names = []
                for (const id of groups) {
                    names.push(USER_GROUP_NAMES[id])
                }
                return names
            },
            organizationActivities() {
                const activities = this.userOrganizationActivities.length ? this.userOrganizationActivities : [];
                let names = []
                for (const id of activities) {
                    names.push(ACTIVITY_NAMES[id])
                }
                return names
            },
            updateUrl() {
                return api.accounts.profile.list()
            },

        },
        methods: {
            showPasswordChangeModal() {
                this.animated = false;
                this.$bvModal.show('password-change');
            },
            onPasswordFormErrorReset() {
                this.animated = false;
            },
            onPasswordFormError() {
                this.animated = true
            },
            update() {
                const vm = this;
                vm.loading = true;
                let data = this.prepareData();
                const objectLabel = 'Профиль';
                return new Promise((resolve, reject) => {
                    httpClient.post(this.updateUrl, data)
                    .then(response => {
                        vm.objectData = response.data;

                        for (const i in vm.$refs) {
                            const ref = vm.$refs[i];
                            if (ref && ref.hasOwnProperty('objectData') && ref.hasOwnProperty('setObjectData')) {
                                ref.setObjectData(response.data);
                            }
                        }
                        vm.clearForm();
                        vm.loading = false;
                        vm.$bvToast.toast( `${objectLabel} обновлен`,
                            {noCloseButton: true, solid: true, autoHideDelay: 5000, variant: 'success'});

                        vm.$store.dispatch(AuthConstants.AuthActions.AUTH_UPDATE_USER, { user: vm.objectData })

                        resolve(response);
                    })
                    .catch(reason => {
                        vm.showErrorToast(reason);
                        reject(reason);
                    });
                })
            },
        },
        beforeMount() {
            this.objectClass = Profile;
            this.objectId = this.userObject.id
            this.apiEntryPoint = api.accounts.profile
            this.objectData = this.userObject
        },
        mounted() {
            this.onMount();
            this.resetForm();
        },

    }
</script>

<style lang="scss" scoped>
    @import "node_modules/bootstrap/scss/functions";
    @import "node_modules/bootstrap/scss/variables";

    .tag {
        background-color: lighten($primary, 42%);
        border-radius: 12px;
        padding: 5px 12px;
        margin-right: 7px;
        margin-top: 5px
    }

    .avatar {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 72px;
        height: 72px;
        border-radius: 50%;
        border: 2px solid $secondary;
        font-size: 40px;
        color: $secondary;
    }

</style>